import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './assets/css/main.scss'
import App from './App.vue'
import { useAuthStore } from './modules/auth'
import { usePortalBrandingStore } from '@/shared/stores/portalBranding'

async function bootstrap() {
  const app = createApp(App)

  app.config.errorHandler = (err, _vm, info) => {
    console.error(`[Global Error] ${info}:`, err)
  }

  const pinia = createPinia()
  app.use(pinia)
  app.use(router)

  const authStore = useAuthStore(pinia)
  authStore.initAuth()

  // Sync session and impersonation states across all open tabs in real-time
  window.addEventListener('storage', (event) => {
    if (event.key === 'auth_token') {
      if (!event.newValue) {
        // Tab logged out
        authStore.clearSession()
        router.push({ name: 'login' })
      } else if (event.newValue !== event.oldValue) {
        // Tab logged in, impersonated, or left impersonation
        window.location.reload()
      }
    }
  })

  const brandingStore = usePortalBrandingStore(pinia)
  await brandingStore.initialize({
    isAuthenticated: authStore.isAuthenticated,
    user: authStore.user,
    fetchProfile: authStore.isAuthenticated
      ? () => authStore.fetchProfile().catch(() => undefined)
      : undefined
  })

  app.mount('#app')
}

void bootstrap()
